import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { InterestZonesService } from '@feature/interest-zones/services/interest-zones.service';
import {
  mapsReadyGuard,
  provideZMaps,
  withConfig,
  withLoader,
} from '@gozetta/z-maps';
import { provideZones, withZoneLocations } from '@gozetta/z-maps/zones';
import { GeoLocationDirective } from '@gozetta/z-maps/shared';
import { LocationsService } from '@core/services';
import { environment } from '@envs/environment';
import { MapLoaderService } from '@shared/services/map-loader.service';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

const MAPS_ID = '6a2150d7d0e6b1dc';

export const interestZonesRoutes: Routes = [
  {
    path: 'interest-zones',
    loadComponent: () =>
      import('./interest-zones.component').then(m => m.InterestZonesComponent),
    providers: [
      InterestZonesService,
      provideZones({ apiUrl: environment.dispatchUrl }),
    ],
  },
  {
    path: 'interest-zones/manage-zones',
    providers: [
      provideZMaps(
        withLoader(
          () =>
            firstValueFrom(
              inject(MapLoaderService)
                .getGoogleAPIConfigurations()
                .pipe(map(c => c.googleKey))
            ),
          ['maps', 'marker', 'places', 'geometry'],
          'lazy'
        ),
        withConfig({ mapId: MAPS_ID })
      ),
      provideZones(
        { apiUrl: environment.dispatchUrl },
        withZoneLocations(LocationsService)
      ),
      GeoLocationDirective,
    ],
    canActivate: [mapsReadyGuard],
    children: [
      {
        path: 'add',
        loadComponent: () =>
          import('@feature/interest-zones/pages/manage-zone/manage-zone.component').then(
            m => m.ManageZoneComponent
          ),
      },
      {
        path: 'edit/:zoneId',
        loadComponent: () =>
          import('@feature/interest-zones/pages/manage-zone/manage-zone.component').then(
            m => m.ManageZoneComponent
          ),
      },
    ],
  },
];
